import styles from './ReviewOrderListItem.scss';

import React from 'react';
import { TextV2 } from 'src/components/TextV2/TextV2';

export type ReviewOrderListItemProps = {
  heading: string;
  description: string;
  icon: string;
};

export const ReviewOrderListItem: React.FC<ReviewOrderListItemProps> = ({
  heading,
  description,
  icon,
}) => {
  return (
    <>
      <div className={styles.reviewOrderListItemIconContainer} aria-hidden="true">
        <div className={styles.reviewOrderListItemCircle}>
          <img className={styles.reviewOrderListItemIcon} src={icon} alt="" />
        </div>
      </div>
      <div className={styles.reviewOrderListItemContent}>
        <TextV2
          tagName="h5"
          variant="body-medium"
          value={heading}
        />
        <TextV2
          tagName="p"
          variant="body"
          value={description}
        />
      </div>
    </>
  );
};
